export enum StudentTabId {
	Classes = 'classes',
	Groups = 'groups',
	Students = 'students',
}
